
export enum UserRole {
  SUPER_ADMIN = 'Super Admin',
  ADMIN = 'Admin',
  INSPECTOR = 'Inspector',
  PIC = 'PIC',
  MANAGEMENT = 'Management'
}

export enum AppFeature {
  DASHBOARD = 'dashboard',
  MASTER_DATA = 'master',
  SCHEDULE = 'schedule',
  INPUT_ACTUAL = 'actual',
  MONITORING = 'monitoring',
  FINDINGS = 'findings',
  REPORTS = 'reports',
  USERS = 'users'
}

export type RolePermissions = Record<UserRole, AppFeature[]>;

export interface AppUser {
  id: string;
  name: string;
  email: string;
  role: UserRole;
  password?: string;
  plant?: string;
  avatar?: string;
}

export interface ActivityLog {
  id: string;
  timestamp: string;
  userId: string;
  userName: string;
  action: string;
  details: string;
}

export enum EquipmentType {
  APAR = 'APAR',
  HYDRANT = 'Fire Hydrant',
  EYEWASH = 'Eyewash',
  SHOWER = 'Safety Shower',
  DETECTOR = 'Alarm & Detector',
  LAMP = 'Emergency Lamp',
  PPE = 'PPE Khusus',
  FIRST_AID = 'Kotak P3K',
  SPILL_KIT = 'Spill Kit',
  STRETCHER = 'Tandu / Stretcher',
  FIRE_BLANKET = 'Fire Blanket'
}

export enum Frequency {
  ONCE = 'Sekali Jalan',
  DAILY = 'Harian',
  WEEKLY = 'Mingguan',
  MONTHLY = 'Bulanan',
  QUARTERLY = 'Tribulanan',
  SEMESTERLY = 'Semesteran',
  YEARLY = 'Tahunan'
}

export enum InspectionStatus {
  OK = 'OK',
  NG = 'NG'
}

export enum FollowUpStatus {
  OPEN = 'Open',
  PENDING_APPROVAL = 'Pending Approval',
  CLOSED = 'Closed'
}

export enum InspectionType {
  ROUTINE = 'Routine (Peralatan)',
  GENBA_WALK = 'Genba Walk',
  GENBA_BOD = 'Genba BOD',
  SAFETY_PATROL = 'Safety Patrol',
  ENV_WALK = 'Environmental Walk',
  FIVE_S = '5R / 5S Audit',
  FIRE_SAFETY = 'Fire Safety Inspection',
  ENERGY_WALK = 'Energy Walk',
  MANAGEMENT_WALK = 'Management Walk',
  FIRE_ELECTRICAL = 'Fire & Electrical Safety',
  WORKPLACE_HEALTH = 'Safety & Healthy Workplace',
  LIFTING_EQUIPMENT = 'Lifting Equipment Safety',
  PROD_RISK = 'Production Area Risk',
  CHEMICAL_PAINTING = 'Chemical & Painting Control',
  SAFETY_CULTURE = 'Safety Culture Review'
}

export enum FindingLevel {
  CRITICAL = 'Critical (BOD Priority)',
  MAJOR = 'Major',
  MINOR = 'Minor',
  OBSERVATION = 'Observation'
}

export enum SQCDME {
  SAFETY = 'Safety',
  QUALITY = 'Quality',
  COST = 'Cost',
  DELIVERY = 'Delivery',
  ENVIRONMENT = 'Environment',
  MORALE = 'Morale'
}

export enum BusinessRisk {
  FATALITY = 'Risiko Fatality',
  COMPLIANCE = 'Risiko Compliance',
  PRODUCTION = 'Risiko Produksi',
  REPUTATION = 'Risiko Reputasi'
}

export interface Equipment {
  id: string;
  code: string;
  type: EquipmentType;
  location: string;
  area: string;
  section: string;
  frequency: Frequency;
  lastInspectionDate?: string;
  nextInspectionDate?: string;
  technicalChecklist: string[];
}

export enum PlanStatus {
  DRAFT = 'Draft',
  SCHEDULED = 'Scheduled',
  IN_PROGRESS = 'In Progress',
  COMPLETED = 'Completed'
}

export interface InspectionPlan {
  id: string;
  equipmentId: string;
  plannedDate: string;
  pic: string;
  type?: InspectionType;
  status: PlanStatus;
}

export interface InspectionActual {
  id: string;
  planId?: string; 
  equipmentId: string;
  actualDate: string;
  status: InspectionStatus;
  inspector: string;
  notes?: string;
  findingId?: string;
  checkItems?: Record<string, boolean>; 
  evidencePhoto?: string;
  inspectionType: InspectionType;
  area: string;
  section: string;
  managementPresent?: string[];
  focusSQCDME?: SQCDME[];
}

export interface Finding {
  id: string;
  inspectionId: string;
  date: string; // The date finding was created/recorded
  description: string;
  area: string;
  section: string;
  equipmentName: string;
  pic: string;
  inspectorName: string;
  targetDate: string;
  status: FollowUpStatus;
  inspectionType: InspectionType;
  level: FindingLevel;
  focus?: SQCDME;
  businessRisk?: BusinessRisk;
  bodRecommendation?: string;
  actionRequired?: string;
  correctiveAction?: string;
  correctivePhoto?: string;
  preventiveAction?: string;
  preventivePhoto?: string;
  adminNote?: string; // Catatan dari Admin saat reject
}

export interface MonitoringRow {
  plan: InspectionPlan;
  actual?: InspectionActual;
  equipment: Equipment;
  complianceStatus: 'On Time' | 'Late' | 'Missed' | 'Pending';
}
